import { createFileRoute } from "@tanstack/react-router"
import { AdminLayout } from "../features/admin/AdminLayout"

// Layout-Route ueber allen _auth.admin.*-Seiten: buendelt das is_admin-Gate an
// einer Stelle, statt es in jede Admin-Seite zu kopieren. Siehe AdminLayout.
export const Route = createFileRoute("/_auth/admin")({
  component: AdminLayout,
})
